import {
  FETCH_SHIPMENTS,
  FETCH_SHIPMENTS_STARTED,
  FETCH_SHIPMENTS_SUCCEEDED,
  FETCH_SHIPMENTS_FAILED,
  CLEAR_SHIPMENTS
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  shipments: [],
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_SHIPMENTS_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case FETCH_SHIPMENTS_SUCCEEDED:
      const { shipments, logs } = action.payload;
      return {
        ...state,
        status: statuses.succeeded,
        shipments: shipments.map(s => ({
          ...s,
          logs: logs.filter(log => log?.shipment?.id === s.id)
        }))
      };
    case FETCH_SHIPMENTS_FAILED:
      return { ...state, status: statuses.failed, shipments: [], error: action.error };
    case FETCH_SHIPMENTS:
      return action.payload;
    case CLEAR_SHIPMENTS:
      return defaultState;
    default:
      return state;
  }
};
